import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[70vh] flex flex-col items-center justify-center overflow-hidden px-4 py-12 pt-20" data-id="element-59">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-60" />

      <div className="max-w-5xl mx-auto flex flex-col items-center gap-8 lg:gap-14 z-10" data-id="element-61">
        <div className="flex-1 text-center w-full max-w-2xl" data-id="element-62">
          <FadeIn data-id="element-63">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-gold-400 leading-tight mb-4" data-id="element-64">
              El Protocolo de Sueño Profundo: Recupera tus 7 Horas de Descanso
              Sin Pastillas
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-65">
            <p className="text-lg md:text-xl text-warmWhite-200 mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-66">
              Diseñado específicamente para mujeres de 50+ que están cansadas de
              despertar a las 3 AM y vivir en una neblina de agotamiento.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-67">
            <CtaButton text="¡Sí, quiero volver a dormir bien!" subtitle="Comprar Ahora!" onClick={scrollToOffer} data-id="element-68" />
          </FadeIn>
        </div>

        <div className="w-full max-w-lg relative" data-id="element-69">
          <motion.div animate={{
          y: [0, -15, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative z-10" data-id="element-70">
            <img src="https://cdn.magicpatterns.com/uploads/k8FSEp1SzoVwTeG4gDD2ZD/SUENO_PROFUNDO.png" alt="El Protocolo de Sueño Profundo en dispositivos" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-71" />
          </motion.div>

          {/* Pulsing glow behind image */}
          <motion.div animate={{
          opacity: [0.3, 0.6, 0.3],
          scale: [0.9, 1.1, 0.9]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-gold-500/20 rounded-full blur-[60px] -z-10" data-id="element-72" />
        </div>
      </div>
    </section>;
}